import { useRef, useState } from "react";
import { useDispatch } from "react-redux";

import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import MDActionConfigurator from "components/MDActionConfigurator";

import { complaintPosting, complaintUpdating } from "actions/complaintActions";

function CreateComplaintButton({ selectOrder }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    complaintNumber: "",
    order: "",
    description: "",
    responseRequirements: [],
  });

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitComplaint = (e) => {
    console.log("🚀 ~ file: index.js:59 ~ handleSubmitComplaint ~ e:", e);
    if (currentState === "edit") {
      dispatch(complaintUpdating(currentData?._id, e));
    } else {
      dispatch(complaintPosting(e));
    }
    handleToggleBackdrop({}, "");
  };

  return (
    <MDBox display="flex" alignItems="center" lineHeight={0}>
      <MDBox mt="auto">
        <MDButton
          component="a"
          href="#"
          rel="noreferrer"
          variant="gradient"
          color="info"
          onClick={() =>
            handleToggleBackdrop(
              {
                _id: "",
                complaintNumber: "",
                order: "",
                description: "",
                responseRequirements: [],
              },
              ""
            )
          }
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;Make Complaint
        </MDButton>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Complaint Config"
        subtitle={`Complaint for ${selectOrder?.service?.service} product: ${selectOrder?.product?.productName} - ${selectOrder?.product?.productNumber} under supplier: ${selectOrder?.supplier?.supplierName}`}
        productAmount={selectOrder?.product?.amount}
        onCompleteConfig={handleSubmitComplaint}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Order",
            placeholderType: "Selected Order",
            dataType: "disabled",
            keyType: "order",
            valueType: selectOrder?._id,
          },
          {
            labelType: "Selected Client",
            placeholderType: "Selected Client",
            dataType: "disabled",
            keyType: "client",
            valueType: selectOrder?.requestedBy?._id,
          },
          {
            labelType: "Complaint Number",
            placeholderType: "Enter Complaint Number",
            dataType: "text",
            keyType: "complaintNumber",
            valueType: currentData?.complaintNumber,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "text",
            keyType: "description",
            valueType: currentData?.description,
          },
          {
            labelType: "Requirements",
            placeholderType: "Select Requirements",
            dataType: "complaintrequirement",
            keyType: "responseRequirements",
            valueType: currentData?.responseRequirements
              ? currentData?.responseRequirements
              : [],
            options: selectOrder?.product?.complaintRequirements
              ? selectOrder?.product?.complaintRequirements
              : [],
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default CreateComplaintButton;
